<template>
<div class="ads-right-wrapper">
<div class="login-container">
  <div class="top-panel">
    <div class="main-box">
      <div
  class="first-inside-box"
  v-if="shouldShowField('roomPrice')"
>
  <div class="price-row" :class="priceSizeClass">
     <p v-if="hasPrice">{{ priceNumbers }}</p>
     <p v-else class="contact-owner">Contact the owner</p>
     <span>/{{ priceLabel }}</span>
  </div>
</div>
      <div class="second-inside-box">
        <span class="subtext">{{ service.serviceType1 }}</span>
        <span class="rooms-subtext">Status - Now Open For Requests</span>
      </div>

      <div class="third-inside-box">
        <div class="image-view profile-img-clickable" @click.stop="goToBusinessProfile">
          <img :src="profileImage  || defaultDP" alt="User profile"/>
          <span class="user-row">
            <router-link
              :to="'/business/' + profileSlug"
              class="username username--link"
              @click.stop
            >{{ service.userDetails?.userName || "Unknown User" }}</router-link>
            <!-- <img
              v-if="isUserVerified"
              src="../../assets/verify-tick.svg"
              alt="Verified"
              class="verify-tick"
              style="width: 14px; height: 14px;"
            /> -->
                <span
  v-if="service.userDetails && (service.userDetails.emailVerified === true || service.userDetails.phoneVerified === true)"
  class="verify-tick"
  title="Verified Account"
  style="margin-left:2px; display:inline-flex; align-items:center; vertical-align:middle;"
>
 <!-- <svg width="1em" height="1em" viewBox="0 0 24 24" style="display:block;" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" fill="#2196F3"/>
    <path d="M9.5 12.5l2 2 4-4" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <circle cx="12" cy="12" r="9.2" stroke="#1976D2" stroke-width="1.6" fill="none"/>
  </svg> -->
  <svg width="26" height="26" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" style="display:block;">
                   <rect x="8" y="20" width="48" height="28" rx="4" fill="#E74C3C"/>
                   <polygon points="32,38 8,20 56,20" fill="#C0392B"/>
                   <polygon points="32,38 8,48 8,20" fill="#000" opacity="0.07"/>
                   <polygon points="32,38 56,48 56,20" fill="#000" opacity="0.07"/>
                   <circle cx="32" cy="20" r="12" fill="#ECECEC"/>
                   <circle cx="32" cy="20" r="8" fill="#26A69A"/>
                   <path d="M29 20l3 3 5-5" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                 </svg>
</span>
          </span>
          
        </div>
        <!-- Rating summary and value under username -->
        <div class="rating-row">
          <span
            v-for="n in 5"
            :key="'summary-star-' + n"
            class="star"
            :class="{ filled: n <= Math.round(averageRating), clickable: canRate }"
            @click="canRate && handleStarClick(n)"
          >★</span>
          <span class="rating-value">({{ averageRating > 0 ? averageRating : '0.0' }})</span>
          <span class="total-reviews-label">({{ totalReviews }} {{ totalReviews === 1 ? 'review' : 'reviews' }})</span>
        </div>
        <!-- Review box: show if showReviewBox is true -->
        <div v-if="showReviewBox" class="write-review-card" style="margin-top: 12px;">
          <h4 class="write-review-title">{{ myExistingReview ? 'Update Your Review' : 'Write a Review' }}</h4>
          <div class="review-stars-input">
            <span
              v-for="n in 5"
              :key="'input-star-' + n"
              class="star-input"
              :class="{ filled: n <= (hoverRating || selectedRating) }"
              @mouseover="hoverRating = n"
              @mouseleave="hoverRating = 0"
              @click="selectedRating = n"
            >★</span>
            <span v-if="selectedRating" class="selected-label">{{ ratingLabels[selectedRating] }}</span>
          </div>
          <textarea
            v-model="reviewText"
            class="review-textarea"
            :placeholder="myExistingReview ? 'Update your review...' : 'Share your experience (optional)...'"
            maxlength="500"
            rows="3"
          ></textarea>
          <div class="review-form-footer">
            <span class="char-count">{{ reviewText.length }}/500</span>
            <button
              class="submit-review-btn"
              :disabled="!selectedRating || submittingReview"
              @click="submitReview"
            >
              {{ submittingReview ? 'Submitting...' : (myExistingReview ? 'Update Review' : 'Submit Review') }}
            </button>
            <button class="cancel-review-btn" :disabled="submittingReview" @click="cancelReview">Cancel</button>
            <button v-if="myExistingReview" class="delete-review-btn" @click="deleteReview(myExistingReview)" style="margin-left: 10px;">Delete</button>
          </div>
        </div>
      </div>

      <div v-if="hasGeoCoordinates" class="map-section">
        <div class="map-frame-wrap">
          <iframe
            class="map-frame"
            :src="mapEmbedUrl"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            allowfullscreen
            title="Service location map"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
<div class="bottom-panel">


<div class="bottom-box">
  <button
    v-if="isOwner"
    class="button1-box"
    @click.stop="editpost(service.servicesID)"
  >
    <span>Edit Post</span>
    <img src="../icons/Property 1=edit (1).svg" class="white-svg1" alt="Edit"/>
    
  </button>

  <template v-else>
        <button
          class="button1-box"
          @click.stop="handleContactOwner"
        >
          <span>Contact Owner</span>
          <img src="../icons/Icons (1).svg" width="20" height="20" alt="Contact" />
        </button>
      </template>

<!-- Feature Post (owner only, live posts, only once placement is switched on
     — modules/featuredPlacement.js). On plans without featured uses left this
     opens the upgrade modal. -->
<button
  v-if="isOwner && service.isActive === 'true' && featuredEnabled"
  class="button2-box"
  :class="featuredActive ? 'unfeatured-btn' : 'featured-btn'"
  :title="featuredActive ? 'Your ad shows in the Featured slots at the top of search results' : `Show this ad at the top of search results for ${featuredDays} days`"
  @click.stop="toggleFeatured"
  :disabled="featureLoading"
>
  <span>{{ featureLoading ? '...' : (featuredActive ? `Featured until ${featuredUntilLabel} · Remove` : `Feature for ${featuredDays} days`) }}</span>
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon :fill="featuredActive ? 'currentColor' : 'none'" points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
</button>

<button
  v-if="isOwner && service.isActive === 'true'"
  class="button2-box disable-btn"
  @click.stop="disableAd"
>
  <span>Disable Ad</span>
  <!-- <img src="../icons/eye-close.svg" width="20" height="20" /> -->
  <img src="../icons/eye-close.svg" class="white-svg" alt="Disable" />

</button>

<!-- OWNER + AD INACTIVE → Enable Ad -->
<button
  v-else-if="isOwner && service.isActive === 'false'"
  class="button2-box enable-btn"
  @click.stop="enableAd"
>
  <span>Enable Ad</span>
  <img src="../icons/Property 1=Eye Open.svg"  class="white-svg" alt="Enable" />
</button>

<!-- NOT OWNER → Send Message -->
<button
  v-else
  class="button2-box"
  @click.stop="handleSendMessage"
>
  <span>Send Message</span>
  <img src="../icons/Icons (2).svg" width="20" height="20" alt="Message" />
</button>
<!-- Report Spam button below Send Message, always rendered but disabled for owners -->

<button
  v-if="!isOwner"
  class="button1-box report-btn"
  @click.stop="openReportModal"
>
  <span>Report Spam</span>
  <img src="../icons/shield-slash.svg" width="20" height="20" alt="Report" class="red-svg" />
</button>

<!-- Admin: edit ANY post. Shown below the contact/message/report actions
     for admins who aren't the owner (owners already have Edit Post above).
     Reuses the same editor (unlimited photo allowance). -->
<button
  v-if="isAdmin && !isOwner"
  class="button1-box admin-edit-btn"
  @click.stop="editpost(service.servicesID)"
>
  <span>Edit Post (Admin)</span>
  <img src="../icons/Property 1=edit (1).svg" class="white-svg1" alt="Edit" />
</button>

<!-- Admin: disable/enable ANY post. Reuses the owner disableAd/enableAd
     handlers (PUT /api/services has no ownership check). -->
<button
  v-if="isAdmin && !isOwner && service.isActive === 'true'"
  class="button2-box disable-btn admin-disable-btn"
  @click.stop="disableAd"
>
  <span>Disable Ad (Admin)</span>
  <img src="../icons/eye-close.svg" class="white-svg" alt="Disable" />
</button>
<button
  v-else-if="isAdmin && !isOwner && service.isActive === 'false'"
  class="button2-box enable-btn admin-disable-btn"
  @click.stop="enableAd"
>
  <span>Enable Ad (Admin)</span>
  <img src="../icons/Property 1=Eye Open.svg" class="white-svg" alt="Enable" />
</button>

</div>


</div>
</div>

<!-- Second map removed — single map is shown inside the right panel above -->
</div>




<div v-if="showLogin">
  <div>
    <AuthModal
      :mode="authMode"
      :service="service"
      :action-type="pendingAction"
      @switchMode="switchMode"
      @close="closeLogin"
      @loginSuccess="onLoginSuccess"
    />
  </div>
</div>
  
<Detailsview
  v-if="showUserModal && selectedService"
  :data="{ 
    name: selectedService.userDetails?.userName ?? 'N/A', 
    email: selectedService.userDetails?.email ?? 'support@renants.com', 
    phone: selectedService.Phone ?? '+1 347-309-5344', 
    location: selectedService.location ?? 'N/A' 
  }"
  @close="closeUserModal"
/>


<PostModal
  v-if="showPostModal"
  :type="postMode"
  :postId="postId"
  @close="showPostModal = false"
/>

  <FloatingView
    v-if="showFloating && selectedService"
    :service="selectedService"
    @close="closeFloating"
  />

  <ReportSpamModal
    v-if="showReportModal"
    :show="showReportModal"
    :disabled="isOwner"
    :report-text="reportText"
    @close="closeReportModal"
    @send="sendReport"
    @update:report-text="val => reportText = val"
  />

  <PricingModal
    v-if="showPricingModal"
    :mode="pricingModalMode"
    @close="showPricingModal = false"
  />

</template>
<script>
import FloatingView from "../pages/SendResponse.vue";
import ViewBusinessProfile from "./ViewBusinessProfile.vue";
import Detailsview from "./Detailsview.vue";
import AuthModal from "./Models/AuthModal.vue";
import { toast } from "vue-sonner";
import defaultDP from "../icons/Avatar.svg";
import userDetailsServices from "../../services/userDetailsService";
import axios from "axios";
import { getRecaptchaToken } from "@/utils/recaptcha";
import PostModal from "./Models/PostModal.vue";
import ReportSpamModal from "./Models/ReportSpamModal.vue";
import PricingModal from "./Models/PricingModal.vue";
import { useAdmin } from "@/composables/useAdmin";
import { trackInteraction } from "@/utils/trackInteraction";
import { getFeaturedConfig, isFeaturedActive } from "@/utils/featuredPlacement";

export default {
  name: "ViewAdsLogin",
  components: { FloatingView, ViewBusinessProfile, AuthModal, PostModal, ReportSpamModal, Detailsview, PricingModal },



  data() {
    return {
      showFloating: false,
      showUserModal: false,
      selectedService: null,
      isvalid: false,
      showLogin: false,
      profileImage: defaultDP,
      authMode: "login",
      showPostModal: false,
      postMode: "new", // new | edit
      postId: null,
      isAdmin: false,
      showReportModal: false,
      reportText: "",
      servicetypes2Map: {},
      fieldVisibility: {},
      userRating: 0,
      hoverRating: 0,
      pendingAction: null, // 'contact' or 'sendMessage'
      featureLoading: false,
      featuredEnabled: false, // placement switched on server-side
      featuredDays: 7,
      showPricingModal: false,
      pricingModalMode: "featured",
            // Review state
      showReviewBox: false,
      averageRating: 0,
      totalReviews: 0,
      ratingBreakdown: { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 },
      reviews: [],
      loadingReviews: false,
      selectedRating: 0,
      reviewText: "",
      submittingReview: false,
      myExistingReview: null,
      currentUserId: localStorage.getItem("userid") || "",
      ratingLabels: {
        1: "Poor",
        2: "Fair",
        3: "Good",
        4: "Very Good",
        5: "Excellent",
      },
    };

  },


  props: {
    service: {
      type: Object,
      required: true,
    },
  },

  computed: {
    featuredActive() {
      return isFeaturedActive(this.service);
    },
    featuredUntilLabel() {
      return this.service?.featuredUntil
        ? new Date(this.service.featuredUntil).toLocaleDateString(undefined, { month: "short", day: "numeric" })
        : "";
    },
    isUserVerified() {
      const u = this.service.userDetails;
      console.log("Checking verification for userDetails:", u);
      return !!u && (
        u.emailVerified === true || u.emailVerified == 'true' || u.emailVerified == 1 ||
        u.phoneVerified === true || u.phoneVerified == 'true' || u.phoneVerified == 1
      );
    },
    isOwner() {
      const localUserId = localStorage.getItem("userid");
      return this.isvalid && localUserId && this.service?.userID === localUserId;
    },
    priceNumbers() {
      const input = String(this.service?.roomPrice ?? "");
      const match = input.match(/[$€£¥]?\d[\d,]*(\.\d+)?/g);
      return match ? match.map(t => this.formatPriceToken(t)).join(" ") : "";
    },
    hasPrice() {
      // A real price exists only if at least one matched number is > 0.
      const input = String(this.service?.roomPrice ?? "");
      const match = input.match(/[$€£¥]?\d[\d,]*(\.\d+)?/g);
      if (!match) return false;
      return match.some(t => {
        const num = parseFloat(t.replace(/[^0-9.]/g, ""));
        return !isNaN(num) && num > 0;
      });
    },
    priceSizeClass() {
      // Scale the price font down as the displayed value gets longer so big
      // numbers (e.g. 4,826,800) don't overflow or dwarf the layout.
      const text = this.hasPrice ? this.priceNumbers : "Contact the owner";
      const len = text.length;
      if (len > 13) return "price-xs";
      if (len > 9) return "price-sm";
      if (len > 6) return "price-md";
      return "price-lg";
    },
    priceLabel() {
      // Find the price field label from the current service type metadata
      const main = this.service.serviceType1;
      const sub = this.service.serviceType2;
      const subtypeObj = this.servicetypes2Map[main]?.find(
        t => t.name === sub
      );
      if (subtypeObj && Array.isArray(subtypeObj.fields)) {
        const priceField = subtypeObj.fields.find(f => f.key === "roomPrice");
        if (priceField && priceField.label) {
          return priceField.label;
        }
      }
      // Fallback
      return "Price";
    },
    canRate() {
      // Prevent owner from rating own business
      const localUserId = localStorage.getItem("userid");
      return localUserId && this.service?.userID && localUserId !== this.service.userID;
    },
    profileSlug() {
      const userName = this.service?.userDetails?.userName;
      const userId = this.service?.userID;
      return userName
        ? userName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
        : userId || '';
    },
    hasGeoCoordinates() {
      // Accepts either { lat, lng } or { latitude, longitude } or as strings/numbers
      const lat = this.service?.latitude ?? this.service?.lat;
      const lng = this.service?.longitude ?? this.service?.lng;
      return lat !== undefined && lat !== null && lat !== '' &&
             lng !== undefined && lng !== null && lng !== '' &&
             !isNaN(Number(lat)) && !isNaN(Number(lng));
    },
    mapEmbedUrl() {
      const useGoogle = import.meta.env.VITE_ENABLE_GOOGLE_API === 'true';
      const lat = this.service?.latitude ?? this.service?.lat;
      const lng = this.service?.longitude ?? this.service?.lng;

      if (useGoogle) {
        const apiKey = import.meta.env.VITE_GOOGLE_API_KEY;
        if (this.hasGeoCoordinates) {
          return `https://www.google.com/maps/embed/v1/search?key=${apiKey}&q=${lat},${lng}&zoom=15&maptype=roadmap`;
        }
        const parts = [
          this.service?.location,
          this.service?.serviceType1,
          this.service?.servicesName,
        ].filter(Boolean);
        if (!parts.length) {
          return `https://www.google.com/maps/embed/v1/search?key=${apiKey}&q=New%20York%2C%20NY`;
        }
        return `https://www.google.com/maps/embed/v1/search?key=${apiKey}&q=${encodeURIComponent(parts.join(", "))}`;
      }

      // OpenStreetMap embed
      if (this.hasGeoCoordinates) {
        const delta = 0.01;
        const bbox = `${lng - delta},${lat - delta},${Number(lng) + delta},${Number(lat) + delta}`;
        return `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat},${lng}`;
      }
      // Fallback: search-based OSM embed centred on US
      const query = encodeURIComponent(
        [this.service?.location, this.service?.serviceType1, this.service?.servicesName].filter(Boolean).join(", ") || "New York, NY"
      );
      return `https://www.openstreetmap.org/export/embed.html?bbox=-74.02,40.7,-73.97,40.75&layer=mapnik`;
    }
  },

 

  mounted() {
    getFeaturedConfig().then(({ enabled, days }) => {
      this.featuredEnabled = enabled;
      this.featuredDays = days;
    });
    console.log("ViewAdsRight mounted with service:", this.service);
    this.verifyToken();
    // Resolve admin role (cached module-level) to gate the admin Edit button.
    (async () => {
      try {
        const { isAdmin, fetchAdminStatus } = useAdmin();
        await fetchAdminStatus();
        this.isAdmin = isAdmin.value;
      } catch (_) {
        this.isAdmin = false;
      }
    })();
    userDetailsServices.getProfileImage(this.service?.userID).then((imgUrl) => {
      this.profileImage = imgUrl || defaultDP;
    });
    // Fetch latest user details to get updated rating
    axios.post("/api/userdetailslist", {
      userID: this.service?.userID,
    }).then((response) => {
      if (response.data && response.data.items && response.data.items[0]) {
        this.service.rating = response.data.items[0].rating || 0;
        console.log("Fetched user details for rating:", response.data.items[0]);
      }
    });
    // Fetch service types and set field visibility for price
    axios.get('/api/servicetypes').then(({ data }) => {
      this.servicetypes2Map = data.servicetypes2Map || {};
      this.setFieldVisibilityForView();
    }).catch(() => {
      this.servicetypes2Map = {};
      this.fieldVisibility = {};
    });
    // Add review summary and reviews fetch here
    this.fetchRatingSummary();
    this.fetchReviews();

    // Fetch user verification info separately
    this.fetchUserVerification();
   
  },
methods: {
     // Format a matched price token (e.g. "$4826800.50") with thousand separators
     // -> "$4,826,800.50", preserving any currency symbol and decimal part.
     formatPriceToken(token) {
       const m = String(token).match(/^([$€£¥]?)(\d[\d,]*)(\.\d+)?$/);
       if (!m) return token;
       // Default to US dollar when no currency symbol was stored, so a bare
       // "4826800" renders as "$4,826,800".
       const symbol = m[1] || "$";
       const intPart = m[2].replace(/,/g, "");
       const decPart = m[3] || "";
       const grouped = Number(intPart).toLocaleString("en-US");
       return symbol + grouped + decPart;
     },
     fetchUserVerification() {
        axios.post("/api/userdetailslist", {
          userID: this.service?.userID,
        }).then((response) => {
          if (response.data && response.data.items && response.data.items[0]) {
            // Only set verification fields, do not overwrite userDetails
            const details = response.data.items[0];
            // Vue.set for reactivity if needed
            if (!this.service.userDetails) this.service.userDetails = {};
            this.service.userDetails.emailVerified = details.emailVerified;
            this.service.userDetails.phoneVerified = details.phoneVerified;
          }
        });
      },
    async toggleFeatured() {
      this.featureLoading = true;
      try {
        const { data } = await axios.post("/api/services/feature", {
          servicesID: this.service.servicesID,
          userID: this.service.userID,
        });
        this.service.isFeatured = data.isFeatured;
        this.service.featuredUntil = data.featuredUntil || null;
        if (data.isFeatured) {
          trackInteraction("featured", "feature-on", { label: this.service.servicesID });
          toast.success(`Featured until ${this.featuredUntilLabel} — your ad now shows at the top of matching search results.`);
        } else {
          toast.success("Featured placement removed.");
        }
      } catch (err) {
        const errorCode = err?.response?.data?.error;
        if (errorCode === "FEATURED_NOT_AVAILABLE" || errorCode === "FEATURED_LIMIT_REACHED") {
          this.pricingModalMode = "featured";
          this.showPricingModal = true;
        } else if (errorCode === "AD_NOT_LIVE" || errorCode === "FEATURED_COMING_SOON") {
          toast.error(err.response.data.message);
        } else {
          toast.error("Failed to update featured status.");
        }
      } finally {
        this.featureLoading = false;
      }
    },

    handleStarClick(n) {
      if (!this.canRate) return;
      this.showReviewBox = true;
      this.selectedRating = n;
      this.hoverRating = 0;
    },
    fetchRatingSummary() {
      axios
        .post("/api/ratingsummary", { targetUserID: this.service?.userID })
        .then(({ data }) => {
          this.averageRating = data.averageRating || 0;
          this.totalReviews = data.totalReviews || 0;
          this.ratingBreakdown = data.ratingBreakdown || {
            5: 0, 4: 0, 3: 0, 2: 0, 1: 0,
          };
        })
        .catch(() => {
          this.averageRating = this.service.rating || 0;
        });
    },
    fetchReviews() {
      this.loadingReviews = true;
      axios
        .post("/api/reviewslist?sortBy=latest&limit=50", {
          targetUserID: this.service?.userID,
        })
        .then(({ data }) => {
          this.reviews = data?.items || [];
          // Check if current user already has a review
          if (this.currentUserId) {
            this.myExistingReview = this.reviews.find(
              (r) => r.reviewerUserID === this.currentUserId
            );
            if (this.myExistingReview) {
              this.selectedRating = this.myExistingReview.rating;
              this.reviewText = this.myExistingReview.reviewText || "";
            }
          }
        })
        .catch((err) => {
          console.error("Error fetching reviews:", err);
        })
        .finally(() => {
          this.loadingReviews = false;
        });
    },
    async submitReview() {
      if (!this.selectedRating) {
        toast.error("Please select a star rating");
        return;
      }
      this.submittingReview = true;
      try {
        const reviewerName =
          localStorage.getItem("username") || "Anonymous";
        const { data } = await axios.post("/api/addreview", {
          targetUserID: this.service?.userID,
          reviewerUserID: this.currentUserId,
          reviewerName,
          rating: this.selectedRating,
          reviewText: this.reviewText.trim(),
        });
        // Update averages
        if (data.averageRating !== undefined) {
          this.averageRating = data.averageRating;
          this.totalReviews = data.totalReviews;
        }
        toast.success(
          this.myExistingReview
            ? "Review updated!"
            : "Thanks for your review!"
        );
        this.showReviewBox = false;
        // Refresh reviews list and summary
        this.fetchReviews();
        this.fetchRatingSummary();
      } catch (err) {
        console.error("Error submitting review:", err);
        toast.error("Failed to submit review. Please try again.");
      } finally {
        this.submittingReview = false;
      }
    },
    cancelReview() {
      // Discard unsaved edits: restore the saved review (or clear for a new one)
      this.selectedRating = this.myExistingReview?.rating || 0;
      this.reviewText = this.myExistingReview?.reviewText || "";
      this.hoverRating = 0;
      this.showReviewBox = false;
    },
    async deleteReview(review) {
      if (!confirm("Delete your review?")) return;
      try {
        await axios.put("/api/deletereview", {
          reviewID: review.reviewID,
          reviewerUserID: this.currentUserId,
        });
        toast.success("Review deleted");
        this.selectedRating = 0;
        this.reviewText = "";
        this.myExistingReview = null;
        this.showReviewBox = false;
        this.fetchReviews();
        this.fetchRatingSummary();
      } catch (err) {
        toast.error("Failed to delete review");
        console.error(err);
      }
    },
 


// --- New logic for login/modal flow ---
  handleContactOwner() {
    trackInteraction('view-listing', 'contact-owner', { label: this.service?.servicesID, role: this._viewRole() });
    if (this.isOwner) {
      window.location.reload();
      return;
    }
    if (!this.isvalid) {
      this.pendingAction = 'contact';
      this.authMode = 'sendResponseLogin';
      this.showLogin = true;
    } else {
      this.openUserModal();
    }
  },
  handleSendMessage() {
    trackInteraction('view-listing', 'send-message', { label: this.service?.servicesID, role: this._viewRole() });
    if (this.isOwner) {
      window.location.reload();
      return;
    }
    if (!this.isvalid) {
      this.pendingAction = 'sendMessage';
      this.authMode = 'sendResponseLogin';
      this.showLogin = true;
    } else {
      this.openFloating();
    }
  },
  onLoginSuccess() {
    this.showLogin = false;
    this.isvalid = true; // Mark user as logged in
    // After login, show the correct modal
    if (this.pendingAction === 'contact') {
      this.openUserModal();
    } else if (this.pendingAction === 'sendMessage') {
      this.openFloating();
    }
    this.pendingAction = null;
  },
      setHover(n) {
      this.hoverRating = n;
    },
rateBusiness(n) {
  axios
    .post("/api/userdetailslist", {
      userID: this.service?.userID,
    })
    .then((response) => {
      console.log("User data fetched for rating:", response.data);

      this.userRating = n;

      const userDetailsID =
        response.data.items && response.data.items[0]?.userDetailsID;

      // If no userDetails record exists, create one
      if (!userDetailsID) {
        return axios.post("/api/adduserdetails", {
          userID: this.service?.userID,
          rating: n,
        });
      } 
      // Otherwise, update existing record
      else {
        return axios.put("/api/updateuserdetails", {
          userDetailsID: userDetailsID,
          userID: this.service?.userID,
          rating: n,
        });
      }
    })
    .then(() => {
      // Runs after either add or update succeeds
      this.service.rating = n;
      toast.success("Thanks for your rating!");
    })
    .catch((err) => {
      toast.error("Failed to submit rating");
      console.error(err);
    });
},

  requireLogin(callback) {
  if (this.isvalid) return callback();
  localStorage.setItem("redirectTo", this.$route.fullPath);

  this.closeAllPopups();
  this.authMode = "login";
  this.showLogin = true;
},


  goToBusinessProfile() {
    const userId = this.service?.userID;
    if (!userId) {
      console.warn('Cannot navigate to business profile: userID is missing');
      return;
    }
    this.$router.push({ name: 'BusinessProfile', params: { slug: this.profileSlug } });
  },

editpost(servicesID) {
  trackInteraction('view-listing', 'edit-post', { label: servicesID, role: this._viewRole() });
  this.requireLogin(() => {
    this.closeAllPopups();

    this.postMode = "edit";
    this.postId = servicesID;
    this.showPostModal = true;
  });
},


  openUserModal() {
    // Prevent showing modal for owner
    if (this.isOwner) return;
    this.requireLogin(() => {
      this.selectedService = this.service;
      this.closeAllPopups();
      this.showUserModal = true;
    });
  },

  openFloating() {
    // Prevent showing modal for owner
    if (this.isOwner) return;
    this.requireLogin(() => {
      this.selectedService = this.service;
      this.closeAllPopups();
      this.showFloating = true;
    });
  },
    closeUserModal() {
      this.showUserModal = false;
    },

    closeFloating() {
      this.showFloating = false;
    },
  switchMode(mode) {
    this.authMode = mode;
  },

  closeLogin() {
    this.showLogin = false;
  },

  closeAllPopups() {
    this.showFloating = false;
    this.showUserModal = false;
    this.showLogin = false;
    this.showPostModal = false;
  },

disableAd() {
  trackInteraction('view-listing', 'disable-ad', { label: this.service?.servicesID, role: this._viewRole() });
  axios.put("/api/services", {
    servicesID: this.service?.servicesID,
    userID: this.service?.userID,
    isActive: "false",
  }).then(() => {
  
    window.location.reload();
      toast.success("Ad Disabled");
  });
},

enableAd() {
  axios.put("/api/services", {
    servicesID: this.service?.servicesID,
    userID: this.service?.userID,
    isActive: "true",
  }).then(() => {
   
    window.location.reload();
     toast.success("Ad Enabled");
  });
},


  verifyToken() {
    const token = localStorage.getItem("auth-token");
    // Guest (no token): asking the server would 401 with "Invalid or expired
    // token", which the global interceptor treats as an expired session and
    // shows the "session expired" banner to a user who never signed in.
    if (!token) {
      this.isvalid = false;
      return;
    }
    axios.post("/api/verify-token", {}, {
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true,
    })
    .then(() => (this.isvalid = true))
    .catch(() => (this.isvalid = false));
  },

         setFieldVisibilityForView() {
      const main = this.service.serviceType1;
      const sub = this.service.serviceType2;
      const subtypeObj = this.servicetypes2Map[main]?.find(
        item => item.name === sub
      );
      this.fieldVisibility = {};
      if (subtypeObj && subtypeObj.fields) {
        subtypeObj.fields.forEach(f => {
          this.fieldVisibility[f.key] = f.show !== false;
        });
      }
    },
    shouldShowField(field) {
      // No subtype selected → show everything
      if (!this.fieldVisibility || !Object.keys(this.fieldVisibility).length) return true;
      const fieldMap = {
        title: "title",
        description: "description",
        location: "location",
        roomPrice: "roomPrice",
        phoneNumber: "phoneNumber",
        email: "email",
        images: "photo",
      };
      // Contact group
      if (field === "contact") {
        return (
          this.fieldVisibility.phoneNumber !== false ||
          this.fieldVisibility.email !== false
        );
      }
      const backendKey = fieldMap[field] || field;
      return this.fieldVisibility[backendKey] !== false;
    },

  // Role label for interaction tracking on the view-listing page.
  _viewRole() {
    if (this.isAdmin && !this.isOwner) return 'admin';
    if (this.isOwner) return 'owner';
    return this.isvalid ? 'user' : 'guest';
  },
  openReportModal() {
      if (this.isOwner) return;
      trackInteraction('view-listing', 'report-spam', { label: this.service?.servicesID, role: this._viewRole() });
      this.reportText = "";
      this.showReportModal = true;
    },
    closeReportModal() {
      this.showReportModal = false;
    },
    sendReport(val) {
      console.log("sendReport called with:", val);
      const reportReason = val || this.reportText || "";
      const userId = localStorage.getItem("userid") || "anonymous";
      const payload = {
        serviceName: this.service?.servicesName || "Unknown",
        serviceType: this.service?.serviceType1 || "",
        serviceId: this.service?.servicesID || "",
        userId,
        reason: reportReason
      };

      console.log("About to POST /api/report", payload);
      axios.post("/api/report", payload)
        .then((res) => {
          console.log("Report API response:", res);
          const serviceLink = window.location.href; // Current service URL
          const htmlMessage = `
            <h2>Spam Report Details</h2>
            <p><strong>Report:</strong> ${reportReason}</p>
            <p><strong>Service Name:</strong> ${payload.serviceName}</p>
            <p><strong>Service Type:</strong> ${payload.serviceType}</p>
            <p><strong>Service ID:</strong> ${payload.serviceId}</p>
            <p><strong>Reported by:</strong> ${userId}</p>
            <p><strong>View Post:</strong> <a href="${serviceLink}" style="color: #667eea; text-decoration: none; font-weight: bold;">Click here to view the reported post</a></p>
          `;
          return getRecaptchaToken('report').then((recaptchaToken) =>
            axios.post('/api/send-email', {
              to: "info@renants.com",
              subject: "Spam Report Added",
              message: htmlMessage,
              isHtml: true,
              recaptchaToken,
            })
          );
        })
        .then((response) => {
          // Email sent
          console.log("email sent.", response);
          this.showReportModal = false;
          this.reportText = "";
           toast.success("Report submitted. Thanks for the report! We’ll review it.");
        })
        .catch((err) => {
          console.error("Report API error:", err);
          toast.error("Failed to submit report.");
          this.showReportModal = false;
          this.reportText = "";
        });
    },
  }
};
</script>


<style scoped>

.ads-right-wrapper {
  width: 100%;
  max-width: 380px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

         
        .rating-row {
          display: flex;
          align-items: center;
          gap: 4px;
          margin-top: 4px;
        }
        .star {
          font-size: 22px;
          color: #d0d6e6;
          cursor: default;
          transition: color 0.2s;
        }
        .star.filled {
          color: #f7b500;
          text-shadow: 0 1px 4px #ffe9a7;
        }
        .star.clickable {
          cursor: pointer;
          transition: color 0.2s;
        }
        .rate-hint {
          font-size: 13px;
          color: #888;
          margin-left: 8px;
        }
        .rating-value {
          font-size: 15px;
          color: #888;
          margin-left: 6px;
        }
        .total-reviews-label {
          font-size: 14px;
          color: #888;
          margin-left: 6px;
        }

        .write-review-card {
          background: #fff;
          border: 1.5px solid #e3eaff;
          width:100%;
          border-radius: 14px;
          padding: 18px 16px;
          margin-bottom: 18px;
        }
        .write-review-title {
          font-size: 16px;
          font-weight: 700;
          color: #23408e;
          margin: 0 0 14px 0;
        }
        .review-stars-input {
          display: flex;
          align-items: center;
          gap: 4px;
          margin-bottom: 14px;
        }
        .star-input {
          font-size: 32px;
          color: #d0d6e6;
          cursor: pointer;
          transition: color 0.15s, transform 0.15s;
          line-height: 1;
        }
        .star-input:hover {
          transform: scale(1.15);
        }
        .star-input.filled {
          color: #f7b500;
          text-shadow: 0 1px 6px rgba(247, 181, 0, 0.3);
        }
        .selected-label {
          font-size: 14px;
          font-weight: 600;
          color: #f7b500;
          margin-left: 10px;
        }
        .review-textarea {
          width: 100%;
          border: 1.5px solid #e3e8f0;
          border-radius: 10px;
          padding: 12px 14px;
          font-size: 14px;
          font-family: var(--font-primary), sans-serif;
          resize: vertical;
          min-height: 70px;
          max-height: 160px;
          outline: none;
          transition: border-color 0.2s;
          box-sizing: border-box;
        }
        .review-textarea:focus {
          border-color: #3467d5;
        }
        .review-form-footer {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          flex-wrap: wrap;
          margin-top: 12px;
          gap: 10px;
        }
        .char-count {
          font-size: 12px;
          color: #aaa;
        }
        .submit-review-btn {
          background: linear-gradient(135deg, #3467d5, #5b8af5);
          color: #fff;
          border: none;
          border-radius: 10px;
          padding: 8px 22px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: opacity 0.2s, transform 0.15s;
        }
        .submit-review-btn:hover:not(:disabled) {
          transform: translateY(-1px);
          opacity: 0.92;
        }
        .submit-review-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        .cancel-review-btn {
          padding: 8px 6px;
          font-size: 14px;
          background: none;
          border: none;
          color: #6b7280;
          font-weight: 600;
          cursor: pointer;
        }
        .cancel-review-btn:hover:not(:disabled) {
          color: #111827;
        }
        .delete-review-btn {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          background: none;
          border: 1px solid #e8e8e8;
          border-radius: 6px;
          padding: 4px 10px;
          font-size: 12px;
          color: #c44;
          cursor: pointer;
          transition: background 0.15s, border-color 0.15s;
        }
        .delete-review-btn:hover {
          background: #fff0f0;
          border-color: #c44;
        }
.login-container {
  /* _Metric item */

  /* Auto layout */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;

  width: 100%;
  max-width:380px;
  /* height: 402px; */

  border: 3px solid #f0f0f0;
  border-radius: 16px;
}
.top-panel {
  /* Frame 65 */

  /* Auto layout */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px;
  gap: 8px;

  max-width: 380px;
  width:100%;
  /* height: 278px; */

  border-radius: 4px;
}
.bottom-panel {

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;

  width: 380px;
  /* height: 200px; */
  border-top: 3px solid #f0f0f0;
   
 
}
.main-box {
  /* Frame 64 */

  /* Auto layout */
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 9px;
  gap: 20px;
  isolation: isolate;

  width: 364px;
  /* height: 262px; */
}

.first-inside-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px;

  width: 346px;
  height: auto;
}
.price-row {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 4px; /* optional spacing between $167 and /Month */
}

.price-row p {
  margin: 0;
  font-family: "Inter";
  font-weight: 600;
  font-size: 44px;
  line-height: 52px;
  color: #141414;
}

/* Auto-scaling tiers driven by priceSizeClass (shorter value = larger font) */
.price-row.price-lg p { font-size: 44px; line-height: 52px; }
.price-row.price-md p { font-size: 36px; line-height: 44px; }
.price-row.price-sm p { font-size: 28px; line-height: 36px; }
.price-row.price-xs p { font-size: 22px; line-height: 30px; }

.price-row span {
  font-family: "Inter";
  font-weight: 600;
  font-size: 22px;
  line-height: 30px;
  color: #141414;
}

.price-row p.contact-owner {
  white-space: nowrap;
}
.second-inside-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  height: auto; /* ✅ Let it grow naturally */
}

.subtext {
  font-family: "Inter";
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  text-align: center;
  color: #181d27;
  margin: 0;
}

.rooms-subtext {
  font-family: "Inter";
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #000;
  margin: 0;
}

.third-inside-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin-top: 12px; /* ✅ Space below Rental section */
  width: 100%;
  height: auto;
}

.image-view {
  display: flex;
  align-items: center;
  gap: 6px;
}

.image-view img {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid #d0d0d0;
  object-fit: cover;
}

.username {
  font-family: "Inter";
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.01em;
  color: #000;
}
.username--link {
  text-decoration: none;
  color: #000;
  transition: color 0.2s;
}
.username--link:hover {
  color: #0d9488;
  text-decoration: underline;
}

.map-section {
  width: 100%;
}

.map-card {
  border: 3px solid #f0f0f0;
  border-radius: 16px;
  padding: 12px;
  background: #fff;
}

.map-header {
  font-family: "Inter";
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #141414;
  margin-bottom: 8px;
  text-align: left;
}

.map-frame-wrap {
  width: 100%;
  border: 1px solid #e6e8ef;
  border-radius: 10px;
  overflow: hidden;
  background: #f8f9fc;
}

.map-frame {
  width: 100%;
  height: 180px;
  border: 0;
  display: block;
}


.bottom-box {
  display: flex;
  flex-direction: column;
  align-items: center; /* ✅ centers buttons horizontally */
  justify-content: center;
  gap: 12px;
  width: 348px;
}

.button1-box,
.button2-box {
  display: flex;
  align-items: center;
  justify-content: center; /* ✅ centers icon + text */
  gap: 8px;
  width: 100%;
  height: 44px;
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}

/* Outlined button */
.button1-box {
  background: #fff;
  color: #3467d5;
  border: 1px solid #3467d5;
}

/* Filled button */
.button2-box {
  background: #3467d5;
  color: #fff;
  border: 1px solid #3467d5;
}
.disable-btn{
background: #3467d5 ;
  border: 1px solid #3467d5;
}
.white-svg{
   width:18px;
   height:18px;
    filter: brightness(0) invert(1);
}
.profile-img-clickable{
cursor: pointer;
}
.white-svg1{
  width:16px; 
  height:16px;
  filter: invert(33%) sepia(31%) saturate(4202%) hue-rotate(211deg) brightness(89%) contrast(92%);
}
.red-svg {
  filter: invert(24%) sepia(97%) saturate(7492%) hue-rotate(357deg) brightness(90%) contrast(90%);
}
.report-btn {
  background: #fff7f7;
  color: #d53434;
  border: 1px solid #d53434;
}
.featured-btn {
  background: #fffbeb;
  color: #d97706;
  border: 1px solid #d97706;
}
.featured-btn svg {
  color: #d97706;
}
.unfeatured-btn {
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #92400e;
}
.unfeatured-btn svg {
  color: #92400e;
}
.report-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: #ffeaea;
  color: #aaa;
  border: 1px solid #eee;
}
.report-btn:hover {
  background: #ffeaea;
}
/* Admin edit: filled blue so it reads as the primary admin action below the
   outlined contact/message/report buttons. */
.admin-edit-btn {
  background: #3467d5;
  color: #fff;
  border: 1px solid #3467d5;
}
.admin-edit-btn:hover {
  background: #2651b1;
}
.admin-edit-btn .white-svg1 {
  filter: brightness(0) invert(1);
}



@media (min-width: 700px) and (max-width: 1200px) {

  .login-container {
    max-width: 100%;
    width: 100%;
    height: auto;
    padding: 16px;
  }

  .top-panel {
    width: 100%;
    max-width: 100%;
    height: auto;
  }

  .main-box {
    width: 100%;
    max-width: 100%;
    height: auto;
  }

  .first-inside-box {
    width: 100%;
    max-width: 100%;
    height: auto;
  }

  .price-row.price-lg p { font-size: 36px; line-height: 44px; }
  .price-row.price-md p { font-size: 30px; line-height: 38px; }
  .price-row.price-sm p { font-size: 24px; line-height: 32px; }
  .price-row.price-xs p { font-size: 20px; line-height: 28px; }

  .price-row span {
    font-size: 18px;
    line-height: 26px;
  }

  .second-inside-box {
    width: 100%;
  }

  .third-inside-box {
    width: 100%;
  }

  .map-frame {
    height: 220px;
  }

  .image-view img {
    width: 40px;
    height: 40px;
  }

  /* --- Buttons Section --- */
  .bottom-panel {
    width: 50%;
    max-width: 100%;
    height: auto;
    padding: 16px 0;
  }

  .bottom-box {
    width: 100%;
    max-width: 100%;
  }

  .button1-box,
  .button2-box {
    width: 100%;
    max-width: 100%;
    height: 48px;
    font-size: 15px;
  }
}
/* Username and verify tick alignment */
.user-row {
  display: flex;
  align-items: center;
  gap: 6px;
}
/* .verify-tick {
  width: 1em;
  height: 1em;
  margin-left: 4px;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
} */
</style>

